export default {
  name: 'HelperInputBtn',
  props: {
    defaultSlotCss: {
      type: String,
      default: 'm-l-xs flex flex-center no-wrap'
    }
  },
  components: {},
  computed: {
    computedClass () {
      return {}
    }
  },
  render (h) {
    return h('div', {staticClass: 'row', class: this.computedClass}, [
      h('div', {
        staticClass: 'col'
      }, this.$slots.input),
      h('div', {
        staticClass: this.defaultSlotCss
      }, this.$slots.default)
    ])
  }
}
